var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AllCountryGreetings'),_c('AllCountryContracts'),_c('AllCountryBillOfLading'),_c('AllCountryContainer'),_c('AllCountryContractRegionGroup'),_c('SecondaryContracts'),_c('ImporterContractRefine')],1)}
var staticRenderFns = []

export { render, staticRenderFns }